import React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import Cart from './components/cart';
import TotalCost from './components/total-cost';

import cartStore from 'src/stores/cart-store';

import useKeyUp from 'src/hooks/use-key-up';
import useOnClickOutside from 'src/hooks/use-on-click-outside';
import useUnmountAnimation from 'src/hooks/use-unmount-animation';
import useWindowScrollBlock from 'src/hooks/use-window-scroll-block';
import useWindowSize from 'src/hooks/use-window-size';
import { Key } from 'src/constants';

import './order-total.scss';

const OrderTotal = observer(() => {
  const { isOpenCart, lotsCount, closeCart } = cartStore;
  const orderTotalRef = React.useRef<HTMLDivElement | null>(null);
  const { unmountComponent, handleAnimationEnd, isUnmounting } = useUnmountAnimation(closeCart);
  const [isBodyScrollBlock, setIsBodyScrollBlock] = React.useState<boolean>(false);
  const { height, width } = useWindowSize();

  const handleCartClose = () => {
    if (isOpenCart) {
      unmountComponent();
    }
  };

  useOnClickOutside(orderTotalRef, handleCartClose);
  useKeyUp(Key.ESCAPE, handleCartClose);
  useWindowScrollBlock(isBodyScrollBlock);

  React.useEffect(() => {
    if (isOpenCart) {
      const isFullHeight = height === orderTotalRef.current?.offsetHeight;

      if (isFullHeight && !isBodyScrollBlock) {
        return setIsBodyScrollBlock(true);
      }

      if (!isFullHeight && isBodyScrollBlock) {
        return setIsBodyScrollBlock(false);
      }
    } else {
      if (isBodyScrollBlock) {
        setIsBodyScrollBlock(false);
      }
    }
  }, [height, isBodyScrollBlock, isOpenCart, lotsCount, width]);

  return (
    <div
      className={classNames('order-total', !isOpenCart && 'order-total_hidden-cart')}
      ref={orderTotalRef}
    >
      <Cart
        className={classNames(
          'order-total__cart',
          isUnmounting && 'cart_hiding',
          isOpenCart && 'cart_show'
        )}
        onAnimationEnd={handleAnimationEnd}
      />
      <TotalCost className="order-total__cost" onCloseCart={unmountComponent} />
    </div>
  );
});

export default OrderTotal;
